import React from 'react';
import {MasterLayout} from 'layout';
import LapBaoCaoDinhKyPage from './LapBaoCaoDinhKyPage.jsx';

class LapBaoCaoDinhKy extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <LapBaoCaoDinhKyPage params={this.props.params}/>
      </MasterLayout>
    );
  }
}
export default LapBaoCaoDinhKy;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-dinh-ky/LapBaoCaoDinhKy.jsx